import { render, staticRenderFns } from "./addOrganization.vue?vue&type=template&id=44aa4f7d&scoped=true&"
import script from "./addOrganization.js?vue&type=script&lang=js&"
export * from "./addOrganization.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa4f7d",
  null
  
)

export default component.exports